<template>
  <footer v-if="siteConfig">
    <!-- <div
      v-if="siteConfig.customerContactPhone || siteConfig.utilityNavContactPhoneTty"
      class="white--text py-12"
      :class="(siteConfig.footerContactBannerColor === 'purple') ? 'warning' : 'info'"
    >
      <div class="content-center">
        <div class="content-constraint">
          <template v-if="siteConfig.customerContactPhone">
              <h2 class="h3" v-if="siteConfig.customerContactDescription">{{ siteConfig.customerContactDescription }}</h2>
              <h2 class="h3" v-else>Let us know how we can help.</h2>
              <a
                v-if="$vuetify.breakpoint.xs"
                :href="'tel:'+siteConfig.customerContactPhone"
                @click="track()"
              >
                <span class="h3">
                  {{ siteConfig.customerContactPhone }}
                </span>
              </a>
              <span v-else class="h3">
                {{ siteConfig.customerContactPhone }}
              </span>
          </template>
          <template v-if="siteConfig.utilityNavContactPhoneTty">
            <a
              v-if="$vuetify.breakpoint.xs"
              :href="'tel:' + siteConfig.utilityNavContactPhoneTty"
              class="ml-3"
            >
              <span class="h3">
                TTY: {{ siteConfig.utilityNavContactPhoneTty }}
              </span>
            </a>
            <span v-else class="h3 ml-3">
              TTY: {{ siteConfig.utilityNavContactPhoneTty }}
            </span>
        </template>
        </div>
      </div>
    </div> -->
    <div class="app-footer primary">
      <div class="content-center">
        <div class="content-constraint">
          <div class="white--text font-medium mt-2 d-flex justify-end">
            Last update: {{ pageLastUpdatedDate | formatDate('MMMM Do YYYY, h:mm a')}}
          </div>
          <v-row class="mt-12">
            <v-col
              cols="12"
              md="6"
              class="d-flex flex-column mx-0 white--text font-small"
            >
              <div class="image-wrapper">
                <img
                  v-if="siteConfig && siteConfig.footerLogo"
                  class="logo mb-4"
                  :src="siteConfig.footerLogo.url"
                  :alt="siteConfig.footerLogo.title"
                />
              </div>
              <small
                v-if="siteConfig.footerBrandDisclaimer"
                class="white--text mb-6"
                style="max-width: 291px"
              >
                {{ siteConfig.footerBrandDisclaimer }}
              </small>
              <div class="d-flex">
                <section class="mr-6">
                  <div class="d-flex flex-column font-weight-bold">
                    <span>{{ siteConfig.address }}</span>
                    <span>{{
                      siteConfig.city +
                      ", " +
                      siteConfig.state +
                      " " +
                      siteConfig.zip
                    }}</span>
                  </div>
                  <div
                    v-if="siteConfig.salesContactPhone"
                    class="d-flex flex-column mt-3"
                  >
                    <h3 class="font-weight-bold footer-header-small">Plan Sales</h3>
                    <a
                      v-if="$vuetify.breakpoint.xs"
                      :href="'tel:' + siteConfig.salesContactPhone"
                      @click="track()"
                      >{{ siteConfig.salesContactPhone }}</a
                    >
                    <span style="white-space: pre" v-else>{{
                      siteConfig.salesContactPhone | phoneBreak
                    }}</span>
                    <a
                      v-if="$vuetify.breakpoint.xs"
                      :href="'tel:' + siteConfig.utilityNavContactPhoneTty"
                      >TTY: {{ siteConfig.utilityNavContactPhoneTty }}</a
                    >
                    <span v-else
                      >TTY: {{ siteConfig.utilityNavContactPhoneTty }}</span
                    >
                  </div>
                  <div
                    v-if="siteConfig.memberContactPhone"
                    class="d-flex flex-column mt-3"
                  >
                    <h3 class="font-weight-bold footer-header-small">Member Services</h3>
                    <a
                      v-if="$vuetify.breakpoint.xs"
                      :href="'tel:' + siteConfig.memberContactPhone"
                      @click="track()"
                      >{{ siteConfig.memberContactPhone }}</a
                    >
                    <span style="white-space: pre" v-else>{{
                      siteConfig.memberContactPhone | phoneBreak
                    }}</span>
                    <a
                      v-if="$vuetify.breakpoint.xs"
                      :href="'tel:' + siteConfig.utilityNavContactPhoneTty"
                      >TTY: {{ siteConfig.utilityNavContactPhoneTty }}</a
                    >
                    <span v-else
                      >TTY: {{ siteConfig.utilityNavContactPhoneTty }}</span
                    >
                  </div>
                  <div
                    v-if="siteConfig.providerPhone"
                    class="d-flex flex-column mt-3"
                  >
                    <h3 class="font-weight-bold footer-header-small">Provider Phone Number</h3>
                    <a
                      v-if="$vuetify.breakpoint.xs"
                      :href="'tel:' + siteConfig.providerPhone"
                      @click="track()"
                      >{{ siteConfig.providerPhone }}</a
                    >
                    <span style="white-space: pre" v-else>{{
                      siteConfig.providerPhone | phoneBreak
                    }}</span>
                    <a
                      v-if="$vuetify.breakpoint.xs"
                      :href="'tel:' + siteConfig.utilityNavContactPhoneTty"
                      >TTY: {{ siteConfig.utilityNavContactPhoneTty }}</a
                    >
                    <span v-else
                      >TTY: {{ siteConfig.utilityNavContactPhoneTty }}</span
                    >
                  </div>
                </section>
                <section class="d-flex flex-column">
                  <div class="mr-6">
                    <ul>
                      <li
                        v-for="(link, i) in siteConfig.footerPageLinks"
                        :key="'footer-page-link_' + i"
                      >
                        <ctf-link
                          class="link my-3"
                          :btn-id="link.sys.id"
                          text-link
                        />
                      </li>
                    </ul>
                  </div>
                  <div class="d-flex">
                    <ul class="side">
                      <li>
                        <a
                          v-if="siteConfig.facebookPage"
                          :href="siteConfig.facebookPage"
                          class="mr-3"
                          aria-label="facebook"
                          @click.prevent="
                            navigateSocial(
                              siteConfig.facebookPage,
                              'Footer_Facebook'
                            )
                          "
                        >
                          <div
                            class="social-icon d-flex align-center justify-center white"
                            aria-hidden="true"
                          >
                            <i class="primary--text fab fa-facebook-f" />
                          </div>
                        </a>
                      </li>
                      <li>
                        <a
                          v-if="siteConfig.youtubePage"
                          :href="siteConfig.youtubePage"
                          class="mr-3"
                          aria-label="youtube"
                          @click.prevent="
                            navigateSocial(
                              siteConfig.youtubePage,
                              'Footer_Youtube'
                            )
                          "
                        >
                          <div
                            class="social-icon d-flex align-center justify-center white"
                            aria-hidden="true"
                          >
                            <i class="primary--text fab fa-youtube" />
                          </div>
                        </a>
                      </li>
                      <li>
                        <a
                          v-if="siteConfig.linkedinPage"
                          :href="siteConfig.linkedinPage"
                          class="mr-3"
                          aria-label="linked-in"
                          @click.prevent="
                            navigateSocial(
                              siteConfig.linkedinPage,
                              'Footer_LinkedIn'
                            )
                          "
                        >
                          <div
                            class="social-icon d-flex align-center justify-center white"
                            aria-hidden="true"
                          >
                            <i class="primary--text fab fa-linkedin-in" />
                          </div>
                        </a>
                      </li>
                      <li>
                        <a
                          v-if="siteConfig.instagramPage"
                          :href="siteConfig.instagramPage"
                          class="mr-3"
                          aria-label="instagram"
                          @click.prevent="
                            navigateSocial(
                              siteConfig.instagramPage,
                              'Footer_Instagram'
                            )
                          "
                        >
                          <div
                            class="social-icon d-flex align-center justify-center white"
                            aria-hidden="true"
                          >
                            <i class="primary--text fab fa-instagram" />
                          </div>
                        </a>
                      </li>
                      <li>
                        <a
                          v-if="siteConfig.twitterPage"
                          :href="siteConfig.twitterPage"
                          class="mr-3"
                          aria-label="twitter"
                          @click.prevent="
                            navigateSocial(
                              siteConfig.twitterPage,
                              'Footer_Twitter'
                            )
                          "
                        >
                          <div
                            class="social-icon d-flex align-center justify-center white"
                            aria-hidden="true"
                          >
                            <i class="primary--text fab fa-twitter" />
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </section>
                <a href="https://allyant.com/">
                  <img
                    src="@/assets/images/Allyant-badge.svg"
                    alt="Reviewed by Allyant for accessibility"
                    style="width: 75px; align-self: start"
                  />
                </a>
              </div>
            </v-col>
            <v-col
              v-if="configAssets"
              cols="12"
              md="6"
              class="mx-0 white--text"
            >

            <div class="footer-descrip-links">
                <ctf-link
                  class="link my-3"
                  :btn-id="siteConfig.accessibilityNoticeLink.sys.id"
                  text-link
                />
                <ctf-link
                  class="link my-3"
                  :btn-id="siteConfig.complaintFormLink.sys.id"
                  text-link
                />
              </div>
              <ctf-rich-text :document="siteConfig.footerDescription" />
              <language-list />
            </v-col>
          </v-row>
          <v-divider class="white" />
          <div class="d-flex white--text pt-0 my-6 bottom-page-links">
            <div>
              &copy; {{ new Date().getFullYear() }}
              {{ siteConfig.copyrightText }}
            </div>
            <div class="d-flex justify-space-between ml-auto">
              <ctf-link
                v-for="(link, i) in siteConfig.bottomPageLinks"
                :key="'bottom-page-link_' + i"
                :btn-id="link.sys.id"
                class="link mx-3"
                text-link
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'
import CtfLink from '@/components/snippets/ctf-link'
import PixelTracker from '@/components/base/pixel-tracker'
import LanguageList from '@/components/snippets/language-list'

export default {
  name: 'TheFooter',
  components: {
    CtfLink,
    LanguageList
  },
  computed: {
    ...mapState('site', ['siteConfig', 'configAssets']),
    ...mapState('layout', ['pageLastUpdatedDate'])
  },
  methods: {
    navigateSocial (link, tracking) {
      if (this.$analytics && tracking) {
        this.$analytics.track(tracking)
      }
      window.open(link, '_blank')
    },
    track () {
      this.siteConfig.careNetworkName.indexOf('Vermont') === -1 ? PixelTracker.track('601117795', 'NNqbCJeDhtwBEOOo0Z4C') : PixelTracker.track('608189871', '_yVMCP2wqNkBEK_7gKIC')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/styles/variables";

.app-footer {
  z-index: 1;
}

@media (max-width: 520px) {
  .bottom-page-links {
    overflow: scroll;
  }
}

.footer-header-small{
  font-size: 15px;
  line-height: 20px;
}

.image-wrapper {
  img {
    max-width: 100%;
    display: block;
    min-width: 291px;
    max-width: 291px;
    min-height: 88px;
    max-height: 88px;
    object-fit: contain;
  }
}

.social-icon {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  i {
    font-size: 24px;
  }
}

ul {
  list-style-type: none;
  padding-left: 0;

  &.side {
    li {
      float: left;
      margin-right: 10px;
    }
  }
}
</style>
